import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";

import { put } from "../../../utils/DeApi";
import { FieldGroup } from "../../../utils/BootstrapUtils";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import Loader from "../../Loader/Loader";

class ProjectUpdate extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      show: false,
      projectName: this.props.project.name
    };

    this.handleShowModal = this._handleShowModal.bind(this);
    this.handleCloseModal = this._handleCloseModal.bind(this);
    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleInputChange = this._handleInputChange.bind(this);
  }

  _handleCloseModal() {
    this.setState({ show: false });
  }

  _handleShowModal() {
    this.setState({ show: true });
  }

  _handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  _handleSubmit(event) {
    event.preventDefault();
    const projectName = this.state.projectName;
    const projectId = this.props.project.id;
    if (projectName) {
      this.setState({ isLoading: true });
      const updatePromise = put("/projects/" + projectId, {
        name: projectName
      });
      updatePromise.promise
        .then(response => {
          this.setState({
            projectName: response.data.name,
            show: false,
            isLoading: false,
            error: ""
          });
          this.props.onProjectUpdated(response.data);
        })
        .catch(error => {
          !error.isCanceled &&
            this.setState({
              error: error,
              isLoading: false
            });
        });
      this.subscribedPromises.push(updatePromise);
    }
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function(promise) {
      promise.cancel();
    });
  }

  render() {
    const { isLoading, projectName, error, show } = this.state;
    const form = isLoading ? (
      <Loader />
    ) : (
      <form onSubmit={this.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title className="mt-0">
            Rename <em>{projectName}</em>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FieldGroup
            id="projectName"
            name="projectName"
            label="Project Name"
            type="text"
            onChange={this.handleInputChange}
            value={projectName}
            maxLength={81}
            placeholder="Enter a name for your project"
            validationState={
              projectName.length > 80 || !projectName ? "error" : null
            }
            required
          />
          {error && <ErrorHandler error={error} />}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleCloseModal}>Cancel</Button>
          <Button type="submit" bsStyle="success">
            Rename
          </Button>
        </Modal.Footer>
      </form>
    );
    return (
      <div>
        <Button bsStyle="link" onClick={this.handleShowModal}>
          Rename Project
        </Button>
        <Modal show={show} onHide={this.handleCloseModal} backdrop="static">
          {form}
        </Modal>
      </div>
    );
  }
}

export default ProjectUpdate;
